(function (module) {
  'use strict';
  module.directive('clientautocomplete', ['$filter', clientAutoCompleteDir]);

  function clientAutoCompleteDir($filter) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        elem.autocomplete({
          source: function (request, response) {
            //term has the data typed by the user
            let params = request.term;

            //simulates api call with data $filter
            let data = scope.dataSource;
            if (data) {
              var result = $filter('filter')(data, {
                name: params,
              });
              _.map(result, function (item) {
                item['value'] = item['name'];
                item['id'] = item['id'];
              });
            }

            response(result);
          },

          select: function (event, ui) {
            $('#hidId').val(ui.item.id);
            scope.selectedValue = ui.item.id;
          },

          minLength: 1,
        }).autocomplete('widget').addClass('client-autocomplete');
      },
    };
  }
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/clientAutoComplete.directive.js